import translate from '../../../../scripts/core/tools/translate';
import environment from '../../../../scripts/environment';

export class WorkshopPartFactory {
    constructor({ options, currentMap }) {
        this.options = options;
        this.currentMap = currentMap;
    }

    getData() {
        const source = environment.get('CONFIG.FILTERS.WORKSHOP_PARTS_TYPES')
            .map(x => ({ text: translate(`Common.${x.nome}`), value: x.id }));

        return [
            {
                name: 'workshop_part_groups',
                position: 1,
                data: source,
                fields: [
                    {
                        title: translate('Common.Type'),
                        name: 'contexts',
                        text: 'text',
                        value: 'value',
                        type: 'multiselect',
                    }
                ]
            }
        ];
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/filters/factory/workshopPart.factory.js